<template>
  <div class="payment-method-settings">
    <v-card tile>
      <v-toolbar
        style="height: auto;"
        elevation="0"
        class=""
        color="white"
      >
        <v-toolbar-title class="pl-5">Aktiva betalningsmetoder på den här enheten</v-toolbar-title>
      </v-toolbar>
      <v-sheet
        class="overflow-y-auto pl-3"
        style="border-top: 1px solid lightgrey;"
      >
        <v-list flat>
          <v-list-item
            v-for="paymentMethod in displayedPaymentMethods"
            :key="paymentMethod.id"
            :disabled="!paymentMethod.allow_user_activation"
          >
            <v-list-item-icon class="my-auto">
              <v-icon v-text="paymentMethod.icon_class_name"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="d-flex width-100" style="white-space: normal;">
                <div class="my-auto d-flex flex-column width-100 pr-5">
                  <div class="text-subtitle-2">{{ paymentMethod.long_name }}</div>
                  <div class="text-body-2">{{ paymentMethod.settings_description }}</div>
                  <div v-show="!paymentMethod.default_account_id" class="text-caption warning--text">Inget bokföringskonto är kopplat till betalmetoden</div>
                </div>
                <div class="ml-auto my-auto">
                  <v-switch
                    :input-value="activePaymentMethodIds.includes(paymentMethod.id)"
                    @click="toggleActivatedPaymentMethod(paymentMethod)"
                    color="secondary"
                    :loading="loadingPaymentMethodIds.includes(paymentMethod.id)"
                    readonly
                  ></v-switch>
                </div>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-alert
          type="info"
          text
          class="mr-3"
        >
          Betalningsmetod kort, med integrerad kortterminal, aktiveras genom att koppla en kortterminal till den här enheten i inställningarna för kortterminaler.
        </v-alert>
      </v-sheet>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import PaymentMethodService from '@/services/PaymentMethodService.js'
import { confirmationDialog } from '@/store/confirmation'

export default {
  name: 'PaymentMethodSettings',
  components: {},
  props: {},
  data: () => ({
    loadingPaymentMethodIds: []
  }),
  computed: {
    ...mapState(
      {
        workstation: state => state.workstation,
        paymentMethods: state => state.posCheckout.paymentMethods
      }
    ),
    displayedPaymentMethods: function () {
      const displayedGateways = ['integrated_terminal', 'card', 'cash', 'swish']
      return this.paymentMethods.filter(paymentMethod => displayedGateways.includes(paymentMethod.gateway))
    },
    activePaymentMethodIds: function () {
      return this.paymentMethods.filter(paymentMethod => paymentMethod.workstation_ids.includes(this.workstation.id)).map(paymentMethod => paymentMethod.id)
    },
    activePaymentMethods: function () {
      if (!this.workstation) {
        return []
      }
      return this.paymentMethods.filter(pm => pm.workstation_ids.includes(this.workstation.id))
    }
  },
  methods: {
    toggleActivatedPaymentMethod: function (paymentMethod) {
      if (this.loadingPaymentMethodIds.includes(paymentMethod.id)) {
        return false
      }

      const associatePaymentMethod = this.activePaymentMethodIds.includes(paymentMethod.id) ? 0 : 1

      // Show confirmation dialog for card payment method activation
      if (paymentMethod.gateway === 'card' && associatePaymentMethod === 1) {
        confirmationDialog({
          header: 'Är du säker?',
          body: 'Den här betalningsmetoden är endast för fristående kortterminal, om ni har en integrerad kortterminal så ska du INTE aktivera den här betalningsmetoden. Vill du fortsätta?',
          confirmFn: () => this.executeActivatePaymentMethod(paymentMethod, associatePaymentMethod)
        })
        return
      }

      this.executeActivatePaymentMethod(paymentMethod, associatePaymentMethod)
    },
    executeActivatePaymentMethod: function (paymentMethod, associatePaymentMethod) {
      this.loadingPaymentMethodIds.push(paymentMethod.id)

      PaymentMethodService.associatePaymentMethodToWorkstation({
        paymentMethodId: paymentMethod.id,
        workstationId: this.workstation.id,
        associatePaymentMethod
      })
        .then(({ data }) => {
          console.log('associatePaymentMethodToWorkstation then', data)
          if (data.status === 'success') {
            if (associatePaymentMethod === 0) {
              // payment method har tagits bort från workstation
              const i = paymentMethod.workstation_ids.findIndex(workstationId => workstationId === this.workstation.id)
              if (i >= 0) {
                paymentMethod.workstation_ids.splice(i, 1)
                this.$store.dispatch('snackbars/createSnackbar', {
                  color: 'success',
                  text: 'Betalningsmetoden har tagits bort från den här enheten'
                })
              }
            } else {
              // payment method har lagts till på workstation
              paymentMethod.workstation_ids.push(this.workstation.id)
              this.$store.dispatch('snackbars/createSnackbar', {
                color: 'success',
                text: 'Betalningsmetoden har lagts till på den här enheten'
              })
            }
          }
        })
        .finally(() => {
          const i = this.loadingPaymentMethodIds.findIndex(id => id === paymentMethod.id)
          this.loadingPaymentMethodIds.splice(i, 1)
        })
    }
  }
}
</script>
